import { SerializedData, Store } from 'bernie-core';
import { observable } from 'mobx';
import { ActionType } from 'types/shared';

export class OpinionLabStore extends Store {
  @observable public label: string;
  @observable public selectAction: ActionType;

  public hydrate(data: SerializedData): void {
    if (data) {
      Object.assign(this, data);
    }
  }
}

OpinionLabStore.DEFAULTS = {};
